import { Suspense } from "react";
import { BrowserRouter } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "./assets/less/yoda-theme.less";
import App from "./App";
import { AuthProvider } from "./context/firebaseContext";
import { BackendProvider } from "./context/backendContext";
import { CustomiseContextProvider } from "./context/customiseContext";
import { initSentry } from "./infrastructure/sentry";

const SERVER_ENV = import.meta.env.APP_ENV || process.env.NODE_ENV || 'development' // Fall back is dev;
initSentry(SERVER_ENV);

const root = createRoot(document.getElementById("root"));
root.render(
  <Suspense fallback="loading">
    <AuthProvider>
      <BackendProvider>
        <CustomiseContextProvider>
          {/* react-router v7 wraps location updates in startTransition. A lazy route
              then suspends without ever committing: the URL changes, the previous page
              stays on screen and only a reload gets you out. */}
          <BrowserRouter useTransitions={false}>
            <App />
          </BrowserRouter>
        </CustomiseContextProvider>
      </BackendProvider>
    </AuthProvider>
  </Suspense>,
);
